import script from "./add-coverage.vue?vue&type=script&setup=true&lang=js"
export * from "./add-coverage.vue?vue&type=script&setup=true&lang=js"

import "./add-coverage.vue?vue&type=style&index=0&id=38b0934e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b0934e"]])

export default __exports__